module.exports = __webpack_public_path__ + "img/dragon.a4741306.png";